import React from "react";
import {
  GatsbyImage,
  IGatsbyImageData,
} from "gatsby-plugin-image";

type getGatsbyImageNodeProps = {
  image: IGatsbyImageData;
  alt: string;
  isContained?: boolean;
  lazyLoading?: boolean;
  offMain?: boolean;
  borderRadius?: string; // Adicionando a prop borderRadius
};

export const getGatsbyImageNode = (
  image: IGatsbyImageData,
  alt: string,
  isContained: boolean = false,
  lazyLoading: boolean = true,
  offMain: boolean = true,
  borderRadius: string = "0px" // Valor padrão para borderRadius
) => {
  return (
    <GatsbyImage
      image={image}
      alt={alt}
      loading={lazyLoading ? "lazy" : "eager"}
      style={{
        width: "100%",
        height: "100%",
        borderRadius: borderRadius, // Aplicando borderRadius ao estilo
      }}
      objectFit={isContained ? "contain" : "cover"}
      objectPosition="center center"
      decoding={offMain ? "async" : "sync"}
    />
  );
};
